export default __webpack_public_path__ + "static/Conditions generales de vente Anglais-4d7470f393767e180cae36caeeabdc1c.pdf";